var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVerifiedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.15237 1.64064C8.3462 1.45312 8.65383 1.45312 8.84766 1.64064L10.1553 2.90563L11.9567 2.65083C12.2237 2.61306 12.4726 2.79387 12.5192 3.05951L12.8335 4.8515L14.4407 5.70422C14.6789 5.83062 14.774 6.12319 14.6556 6.36548L13.8566 8L14.6556 9.63452C14.774 9.87681 14.6789 10.1694 14.4407 10.2958L12.8335 11.1485L12.5192 12.9405C12.4726 13.2061 12.2237 13.3869 11.9567 13.3492L10.1553 13.0944L8.84766 14.3594C8.65383 14.5469 8.3462 14.5469 8.15237 14.3594L6.84475 13.0944L5.04333 13.3492C4.77629 13.3869 4.52742 13.2061 4.48082 12.9405L4.16648 11.1485L2.55933 10.2958C2.32109 10.1694 2.22603 9.87681 2.34447 9.63452L3.14347 8L2.34447 6.36548C2.22603 6.12319 2.32109 5.83062 2.55933 5.70422L4.16648 4.8515L4.48082 3.05951C4.52742 2.79387 4.77629 2.61306 5.04333 2.65083L6.84475 2.90563L8.15237 1.64064ZM10.8904 6.97901C11.0629 6.76338 11.028 6.44874 10.8123 6.27623C10.5967 6.10373 10.2821 6.13869 10.1096 6.35432L7.79187 9.25143L6.85355 8.31311C6.65829 8.11785 6.34171 8.11785 6.14645 8.31311C5.95118 8.50838 5.95118 8.82496 6.14645 9.02022L7.47978 10.3536C7.58035 10.4541 7.71898 10.5071 7.86098 10.4992C8.00299 10.4914 8.13492 10.4234 8.22377 10.3123L10.8904 6.97901Z",
    fill: "var(--ncap-300)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerifiedIcon);
export default __webpack_public_path__ + "static/media/verified-icon.b3bf14fdd71dc736eeebbd0b63f1d25f.svg";
export { ForwardRef as ReactComponent };